<template>
	<div ref="container" 
		class="overflow-hidden container-visibility relative">
		<div :style="iframeStyle" v-if="videoSrc" class="frame absolute overflow-hidden">
			<VideoBg class="element" :src="videoSrc" :visible="visible" />
		</div>
		<VimeoBg class="element" v-else-if="vimeoId" :id="vimeoId" :visible="visible" />
	</div>
</template>
<script>

/**
 * This video will stretch to fill its container, and crop accordignly. It will
 * get taller than the container or wider container as it needs to, based on 
 * the aspect ratio of the video. That's the idea anyway.
 */

import VideoBg from "@components/misc/video-bg.vue";
import VimeoBg from "@components/misc/vimeo-bg.vue";

export default {
	props: {

		// Pass EITHER OR. No sense in adding both...
		vimeoId: {
			type: String,
			default: '',
		},
		videoSrc: {
			type: String,
			default: '',
		},
		// It's only necessary to pass in W and H for MP4s as Vue has no way
		// of knowing. but the default is 16x9 so in most cases, can be
		// ignored.

		// But, in the case of VIMEO we can get it from the API, where it will 
		// be correct. 
		w: {
			type: Number,
			default: 16,
		},
		h: {
			type: Number,
			default: 9,
		}
	},
	components: {
		VimeoBg,
		VideoBg
	},
	data() {
		return {
			visible: false,

			// Gets changed...
			iframeStyle: {
				width: 0,
				height: 0,
			},

		}
	},
	computed: {
		ratio() {
			return this.h / this.w;
		},
		inverseRatio() {	
			return this.w / this.h;
		},
	},
	mounted() {
		this.intersectionObserver();
		this.resize();
		window.addEventListener('resize', this.resize );
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resize );
	},
	methods: {
		intersectionObserver() {
			if ( 'IntersectionObserver' in window ) {
				this.io = new IntersectionObserver( this.intersectionFn, {
					rootMargin: '200px 0px 200px 0px'
				} );
				this.io.observe( this.$refs.container );	
			}
		},
		intersectionFn( entries ) {
			entries.forEach(element => {
				
				if ( element.isIntersecting ) {
					this.visible = true;
					
				} else {
					this.visible = false;
				}
				
			});
		},
		resize() {
			const container = this.$refs.container;
			const w = container.offsetWidth;
			const h = container.offsetHeight;
			const windowRatio = h / w;

			if (windowRatio > this.ratio) {
				this.iframeStyle.width = `${h * (this.inverseRatio)}px`;
				this.iframeStyle.height = `${h}px`;
			} else {
				this.iframeStyle.width = `${w}px`;
				this.iframeStyle.height = `${w * (this.ratio)}px`;
			}
		}
	}
}
</script>

<style>
.frame .element {
	width: 100%;
	height: 100%;
	position: relative;
	left: 0;
	top: 0;
}
</style>


<style scoped>
.container-visibility {
	transition: opacity .3s ease;
}

.frame {
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
}

.handstick {
	left: -2px;
	top: -2px;
	bottom: -2px;
	right: -2px;
}


</style>
